import React from "react"
import { Grid, Button, Icon } from "semantic-ui-react"
import { Link } from "react-router-dom"
import "./Introduction.css"

export const Introduction = props => {
  const { continueUrl } = props
  return (
    <Grid centered>
      <Grid.Row>
        <Grid.Column textAlign="center">
          <h2 className="UnderstandIntroduction__Heading">
            Understand Your Finances
          </h2>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column
          className="UnderstandIntroduction__Description"
          width={14}
          textAlign="center"
        >
          <p>
            The next step on your journey to clarity, confidence and control is
            understanding your financial picture so you know your opportunities.
          </p>
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column textAlign="center">
          <div className="UnderstandIntroduction__VideoHolder">
            <div style={{ padding: "56.25% 0 0 0", position: "relative" }}>
              <iframe
                title="Introduction Video"
                src="https://player.vimeo.com/video/238651987?title=0&byline=0&portrait=0"
                style={{
                  position: "absolute",
                  top: "0",
                  left: "0",
                  width: "100%",
                  height: "100%"
                }}
                frameBorder="0"
                webkitallowfullscreen="true"
                mozallowfullscreen="true"
                allowFullScreen={true}
              />
            </div>
            <script src="https://player.vimeo.com/api/player.js" />
          </div>
          <div
            className="UnderstandIntroduction__Skip"
            style={{ paddingBottom: "2em" }}
          >
            <div style={{ paddingBottom: "2em" }}>
              <p>
                We'll ask you a few simple questions. It takes about 5 minutes
                and you will:
              </p>
              <ul className="OrganizeIntroduction__List">
                <li>
                  <span>
                    <Icon name="chevron right" size="small" />
                    Understand the impact of taxes on your “net pay”
                  </span>
                </li>
                <li>
                  <span>
                    <Icon name="chevron right" size="small" />
                    See how debt payments and healthcare expenses impact
                    lifestyle spending
                  </span>
                </li>
                <li>
                  <span>
                    <Icon name="chevron right" size="small" />
                    Estimate what’s leftover for everything else (we call this
                    “general spending”)
                  </span>
                </li>
              </ul>
              <br />
              <p>Are you ready to dive in?</p>
            </div>
            <Link to={continueUrl} className="navlink">
              <Button primary size="big" data-testid="continue">
                I'm Ready!
              </Button>
            </Link>
          </div>
        </Grid.Column>
      </Grid.Row>
    </Grid>
  )
}
